import styled from 'styled-components';
import {styledByTheme} from '../../../themes/architecture/styled-by-theme';

const IdleRecommendationToasterBackgroundDefaultBox = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 78%;
    z-index: -1;
    background-image: url(${({theme}) => '"' + theme.images.idleRecommendationToasterBg + '"'});
    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: radial-gradient(rgba(2,0,36,0) 30%, rgb(35, 35, 35) 75%);
        // background: radial-gradient(circle, rgba(0,0,0,0) 30%, rgb(35, 35, 35) 100%);
    }
`;

const IdleRecommendationToasterBackgroundMrGreenBox = styled(IdleRecommendationToasterBackgroundDefaultBox)`
    background-image: none;
    &::before {
        background: radial-gradient(rgba(2,0,36,0) 30%, rgb(255, 255, 255) 75%);
    }
`

export const IdleRecommendationToasterBackgroundBox = styledByTheme(IdleRecommendationToasterBackgroundDefaultBox)
    .forMrGreen(IdleRecommendationToasterBackgroundMrGreenBox)
    .apply();